// components/CTASection.js
import React from 'react';
import { Link } from 'react-router-dom';

const CTASection = ({ onGetQuote }) => {
  return (
    <div className="relative mb-32 overflow-hidden">
      <div className="p-12 bg-gradient-to-r from-black via-gray-900 to-red-900 rounded-3xl shadow-2xl">
        {/* Background Pattern */}
        <div className="absolute inset-0 opacity-5">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent"></div>
        </div>
        
        {/* Animated Elements */}
        <div className="absolute top-0 left-0 w-20 h-20 bg-red-500 rounded-full filter blur-2xl opacity-20 animate-float"></div>
        <div className="absolute bottom-0 right-0 w-32 h-32 bg-red-600 rounded-full filter blur-3xl opacity-20 animate-float-delayed"></div>
        
        {/* Content */}
        <div className="relative z-10 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Need a Custom Solution?
          </h2>
          <p className="text-gray-300 mb-10 max-w-2xl mx-auto text-lg">
            Contact us to discuss your specific requirements. We can help with custom projects of any size or complexity.
          </p>
          
          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link 
              to="/contact"
              className="group px-8 py-4 rounded-full bg-white text-red-700 font-bold text-lg hover:bg-gray-100 shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2"
            >
              <span>Contact Us</span>
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-5 w-5 transform group-hover:translate-x-1 transition-transform" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </Link>
            <button 
              className="group px-8 py-4 rounded-full bg-transparent border-2 border-white text-white font-bold text-lg hover:bg-white hover:bg-opacity-10 shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2"
              onClick={onGetQuote}
            >
              <span>Get a Quote</span>
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                className="h-5 w-5 transform group-hover:translate-y-1 transition-transform" 
                fill="none" 
                viewBox="0 0 24 24" 
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
              </svg>
            </button>
          </div>
        </div>
      </div>
      
      {/* CSS for animations */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        
        .animate-float-delayed {
          animation: float 8s ease-in-out infinite;
          animation-delay: 1s;
        }
      `}</style>
    </div>
  );
};

export default CTASection;